import { relacao_de_aluno_sem_fase_origem } from "./relacao-de-aluno-sem-fase-origem/index";
import { manutencao_de_fase_origem_do_aluno } from "./manutencao-de-fase-origem-do-aluno/index";
import { resumo_da_escola } from "@/router/apoio-gerencial-gestao-de-classe/resumo-da-escola";
import { resumo_de_vagas } from "@/router/apoio-gerencial-gestao-de-classe/resumo-de-vagas";

const apoio_gerencial_gestao_de_classe = [
  ...relacao_de_aluno_sem_fase_origem,
  ...manutencao_de_fase_origem_do_aluno,
  ...resumo_da_escola,
  ...resumo_de_vagas,
];

export { apoio_gerencial_gestao_de_classe };
